export default __webpack_public_path__ + "static/media/mb.a27dc47f.xlsx";